Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Stepper3810895612",
  {"root":"Stepper3810895612--root"},
  ".Stepper3810895612--root{display:flex;min-width:0}.Stepper3810895612--root[data-stepper3810895612-fit=stretched]{flex-grow:1;justify-content:space-between}.Stepper3810895612--root[data-stepper3810895612-fit=stretched]::after{content:''}",
  1,
  "Stepper3810895612"
);
__webpack_require__.stylable.$.register(exports.default)
